<template>
    <form v-show="isInputFormActive" method="POST">
        <div class="row">
            <div class="col-lg-4 col-md-4 col-12">
                <div class="form-group">
                    <label for="itemname">
                        {{ localizationStore.translate("credit.bureau") }}
                    </label>
                    <select
                        v-model="selectedCreditBureauId"
                        @change="getCreditBureauList(selectedCreditBureauId)"
                        id="creditbureau"
                        name="creditbureau"
                        class="form-control"
                        :class="{'is-invalid' : creditBureauError}"
                        required
                    >
                        <option v-for="creditBureau in creditBureaus" v-bind:value="creditBureau.id">{{ creditBureau.name }}</option>
                    </select>
                    <span v-if="creditBureauError" class="invalid-feedback" role="alert">
                        <strong>Field is Required</strong>
                    </span>
                </div>
            </div>
            <div class="col-lg-8 col-md-8 col-12">
                <!-- search input -->
                <div class="custom-search d-flex justify-content-end">
                    <div class="form-group">
                        <label>&nbsp;</label>
                        <div class="d-flex align-items-center">
                            <label class="mr-1">Search</label>
                            <input
                                v-model="searchTerm"
                                placeholder="Search"
                                type="text"
                                class="d-inline-block form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <vue-good-table
      v-show="isInputFormActive"
      ref="inquiry-table"
      v-on:selected-rows-change="creditorSelectionChanged"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }"
      :select-options="{
        enabled: true,
        disableSelectInfo: true,
        selectOnCheckboxOnly: true
      }"
    >
        <template #table-row="props">
            <span v-if="props.column.field === 'action'">
                <div class="d-flex align-items-center col-actions">
                    <a class="mr-1 text-primary" data-toggle="tooltip" data-placement="top" title="Individual Dispute">
                        <vue-feather type="send" @click="dispute(props.row.id)"></vue-feather>
                    </a>
                </div>
            </span>
        </template>
    </vue-good-table>
    <section v-show="!isInputFormActive">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="goBack" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                        <div class="card-body">
                            <form :action="routes.createLetterRoute" method="post" enctype="multipart/form-data" class="row">
                                <input type="hidden" name="_token" :value="csrf">
                                <input type="text" class="form-control" id="creditbureau" name="creditbureau" :value="selectedCreditBureauId" hidden>
                                <div class="col-md-6 pl-md-0 pr-md-3">
                                    <div id="editor">
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="submit" name="editorType" value="1">
                                            {{ localizationStore.translate("letter.left.submit.button.text") }}
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-6 pl-md-3 pr-md-0 mt-3 mt-md-0">
                                    <div class="arrow-btn">
                                        <button
                                            class="btn btn-outline-primary px-50"
                                            @click="$refs.spinner.spinLetter()"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("spin.letter.button.text") }}
                                            <i data-feather="arrow-right"></i>
                                        </button>
                                    </div>
                                    <div id="editor-right">
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="submit" name="editorType" value="2">
                                            {{ localizationStore.translate("letter.right.submit.button.text") }}
                                        </button>
                                    </div>
                                </div>
                                <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRefSingle' />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div ref="editorRefSingle" hidden>
            <div class="page">
                <p>
                    {{ userInfo.firstname }} {{ userInfo.lastname }}
                    <br /> {{ userInfo.address }}
                    <br /> {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zipcode }}
                    <br /> {{ userInfo.ssn }}
                    <br />
                    <br /> {{ selectedCreditBureau.address_name }}
                    <br /> {{ selectedCreditBureau.street_address }}
                    <br /> {{ selectedCreditBureau.city }}, {{ selectedCreditBureau.state_abbrev }} {{ selectedCreditBureau.zipcode }}
                    <br />
                    <br /> Date: {{ date }}
                </p>
                <p>
                    Dear {{ selectedCreditBureau.name }}: <br>
                    RE: SSN #{{ userInfo.ssn }}
                </p>
                <p  class="letter-content" v-if="selectedCreditor.length > 0">
                    This letter in reference to account #<strong>{{ selectedCreditor[0].account_number }}</strong>,
                    my name is {{ userInfo.firstname }} {{ userInfo.lastname }}, my social security number
                    is {{ userInfo.ssn }}, my date of birth is {{ userInfo.dob }}.
                </p>
                <p  class="letter-content" v-if="selectedCreditor.length > 0">
                    This letter is in reference to the account listed on my credit report by
                    Creditor: <strong>{{ selectedCreditor[0].furnisher_name }}</strong> under Account: <strong>{{ selectedCreditor[0].account_number }}</strong>
                    This account is being illegally reported on my credit report.
                    I formally disputed it directly with <strong>{{ selectedCreditor[0].furnisher_name }}</strong> in regards to their
                    illegal reporting, and have <strong>NOT</strong> received any satisfactory reply.
                </p>
                <p class="letter-content">
                    Therefore, I am now formally disputing directly with you. Furthermore, if at any
                    time during your investigation the above account is verified by
                    <strong><mark>(Insert Company Name)</mark> </strong> I am requesting your method of verification pursuant to the FCRA,
                    including the name of the person with whom you spoke, who has firsthand
                    knowledge of the account in question.
                </p>
                <p class="letter-content">
                    I am maintaining a careful record of my communication with you for the purpose
                    of filing a complaint with the Consumer Financial Protection Bureau and the
                    Attorney General's Office, should you continue reporting this erroneous item.
                </p>
                <p>
                    {{ userInfo.firstname}} {{ userInfo.lastname }}
                </p>
                <p>
                    Cc: Consumer Financial Protection Bureau <br />
                    Cc: Attorney General's Office <br />
                    Cc: Better Business Bureau
                </p>
            </div>
        </div>
    </section>
</template>
<script>
  import { reactive, computed, ref } from 'vue'
  import 'vue-good-table-next/dist/vue-good-table-next.css'
  import { VueGoodTable } from 'vue-good-table-next';
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  export default {
    props: {
        csrf: {
            type: String
        },
        creditBureaus: {
            type: [Array, Object]
        },
        userInfo: {
            type: [Array, Object]
        },
    },
    components: {
        VueGoodTable,
    },
    setup(props) {
        return {
            selectedCreditBureauId: ref(props.creditBureaus[0].id),
            editorRefSingle: ref(null),
            isInputFormActive: ref(true),
            creditBureauError: ref(false),
            date: ref(null),
            localizationStore: useLocalizationStore()
        };
    },
    data(){
        const selectedCreditor = reactive([]);
        return {
          columns: [
            {
              label: 'CREDITOR',
              field: 'furnisher_name',
            },
            {
              label: 'ACCOUNT NUMBER',
              field: 'account_number',
            },
            {
              label: 'PAYMENT STATUS',
              field: 'payment_status',
            },
            {
              label: 'Action',
              field: 'action',
            }
          ],
          rows: [],
          searchTerm: '',
          selectedCreditor
        };
    },
    created() {
    },
    mounted() {
        axios.get(this.routes.currentDate).then(response => (this.date = response.data));
        this.getCreditBureauList(this.selectedCreditBureauId);
    },
    computed: {
        // a computed getter
        selectedCreditBureau() {
            return this.creditBureaus.find((attribute) => {
                if (attribute.id == this.selectedCreditBureauId) {
                    return attribute;
                }
            })
        },
        isCreditBureauSelected() {
            return (this.selectedCreditBureauId == null || this.selectedCreditBureauId == "null") ? false : true;
        }
    },
    methods: {
      dispute: function (id) {
        this.selectedCreditor[0] = this.rows.find((attribute) => {
            if (attribute.id == id) {
                return attribute;
            }
        });
        setTimeout(() => {
            tinymce.get('editor').setContent(this.editorRefSingle.innerHTML);
            this.isInputFormActive = !this.isInputFormActive;
        }, "100");
      },
      goBack: function () {
        this.isInputFormActive = !this.isInputFormActive;
      },
      validate: function () {
        if (this.selectedCreditBureauId == null || this.selectedCreditBureauId == "null") {
            this.creditBureauError = true;
        }
        else {
            this.creditBureauError = false;
        }
        return !this.creditBureauError;
      },
      getCreditBureauList: function (type) {
        axios.get(this.routes.listCreditBureau.replace(':type', type)).then(response => {
                this.rows = response.data.data
            }
        );
      },
      creditorSelectionChanged: function (params) {
        this.selectedCreditor = params.selectedRows;
      }
    }
  };
</script>
